import React, { createContext, useContext, useState, useMemo } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    const addItem = (item) => {
        setItems((prev) => {
            const existing = prev.find((p) => p.id === item.id);
            if (existing) {
                return prev.map((p) =>
                    p.id === item.id ? { ...p, quantity: p.quantity + 1 } : p,
                );
            }
            return [...prev, { ...item, quantity: 1 }];
        });
        setIsOpen(true);
    };

    const updateQty = (id, delta) => {
        setItems((prev) =>
            prev
                .map((p) =>
                    p.id === id
                        ? { ...p, quantity: Math.max(0, p.quantity + delta) }
                        : p,
                )
                .filter((p) => p.quantity > 0),
        );
    };

    const removeItem = (id) => {
        setItems((prev) => prev.filter((p) => p.id !== id));
    };

    const clearCart = () => setItems([]);

    const total = useMemo(
        () => items.reduce((sum, i) => sum + i.price * i.quantity, 0),
        [items],
    );
    const count = useMemo(
        () => items.reduce((sum, i) => sum + i.quantity, 0),
        [items],
    );

    return (
        <CartContext.Provider
            value={{
                items,
                addItem,
                updateQty,
                removeItem,
                clearCart,
                total,
                count,
                isOpen,
                setIsOpen,
            }}
        >
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => {
    const ctx = useContext(CartContext);
    if (!ctx) throw new Error("useCart must be used within CartProvider");
    return ctx;
};
